/* custom-marketing.js — rewards marquee + others (robust) */
(function () {
  'use strict';
  var $ = window.jQuery;
  if (!$) { console.error('[marketing] jQuery missing'); return; }

  // ---------- helpers ----------
  function imagesReady($ctx, cb) {
    var $imgs = $ctx.find('img');
    if (!$imgs.length) return cb();
    var left = $imgs.length;
    $imgs.each(function () {
      var img = this;
      if (img.complete) { if (--left === 0) cb(); }
      else $(img).one('load error', function () { if (--left === 0) cb(); });
    });
  }

  function getContentWidth($el) {
    var w = 0;
    // measure immediate children; fallback to scrollWidth
    $el.children().each(function () { w += $(this).outerWidth(true) || 0; });
    return w || ($el.get(0) ? $el.get(0).scrollWidth : 0);
  }

  function initOne($el, opts) {
    if (!$el.length || !$el.is(':visible')) return;
    if ($el.data('marquee-initialized')) return;
    if (!$.fn.marquee) { console.warn('[marketing] jquery.marquee not loaded'); return; }

    imagesReady($el, function () {
      // constant speed (px/s) → duration from content width
      var SPEED = opts.speedPxPerSec || 80;
      var contentW = getContentWidth($el);
      var boxW = $el.innerWidth();
      var duration = Math.max(6000, Math.round((contentW + boxW) / SPEED * 1000));

      $el.marquee({
        duration: duration,
        gap: opts.gap || 20,
        direction: opts.direction || 'left',
        delayBeforeStart: 0,
        duplicated: true,
        startVisible: true,      // keeps first frame visible
        pauseOnHover: true
      });

      $el.data('marquee-initialized', true);
    });
  }

  function initAll(root) {
    var $root = root ? $(root) : $(document);

    // REWARDS
    $root.find('.rewards-marquee').each(function () {
      initOne($(this), { speedPxPerSec: 80, gap: 20 });
    });

    // Existing strips (if present)
    $root.find('.marquee-imgs').each(function () {
      initOne($(this), { speedPxPerSec: 110, gap: 30 });
    });
    $root.find('.hm-marquee').each(function () {
      initOne($(this), { speedPxPerSec: 70, gap: 30 });
    });
  }

  // Lazy-init when near viewport (if present)
  function initWhenVisible(root) {
    var sel = '.rewards-marquee, .marquee-imgs, .hm-marquee';
    var els = (root || document).querySelectorAll(sel);
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          initAll(entry.target.parentNode || document);
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '200px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      initAll(root);
    }

    // failsafe: force init after a moment even if IO didn't fire
    setTimeout(function(){ initAll(root); }, 1500);
  }

  function initVeno() {
  if (!$.fn.venobox) return;

  $('.hero-video-btn-link').venobox({
    autoplay: true
  });
}

$(document).ready(initVeno);
document.addEventListener('shopify:section:load', initVeno);

  // Kickoff + reinit on section load / resize
  window.addEventListener('load', function(){ initWhenVisible(document); }, { passive:true });

  document.addEventListener('shopify:section:load', function (e) {
    initWhenVisible(e.target);
  });

  var debounce = (window.utils && window.utils.debounce) || function (fn, w) {
    var t; return function(){ clearTimeout(t); t=setTimeout(fn, w||200); };
  };
  $(window).on('resize', debounce(function(){
    // destroy & re-init with new width
    $('.rewards-marquee, .marquee-imgs, .hm-marquee').each(function(){
      var $el = $(this);
      if ($el.data('marquee-initialized')) {
        try { $el.marquee('destroy'); } catch(e){}
        $el.removeData('marquee-initialized');
      }
    });
    initAll(document);
  }, 250));
})();
